import { render, staticRenderFns } from "./RelevantSearch.vue?vue&type=template&id=dda65338&scoped=true"
import script from "./RelevantSearch.vue?vue&type=script&lang=js"
export * from "./RelevantSearch.vue?vue&type=script&lang=js"
import style0 from "./RelevantSearch.vue?vue&type=style&index=0&id=dda65338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda65338",
  null
  
)

export default component.exports